import { capitalizeFirst, isNull } from "App/utils/helpers";
import React, { useState } from "react";
import ModalLogout from "./ModalLogout";
import { getUserName } from "App/utils/cookies";

function UserInformationWihoutSso({ themeList }) {
  const [showModalLogout, setShowModalLogout] = useState(false);

  const handleClickLogout = () => {
    setShowModalLogout(!showModalLogout);
  };

  return (
    <>
      {showModalLogout && (
        <ModalLogout setShowModal={() => setShowModalLogout(false)} />
      )}

      <div
        className='top-nav-bars'
        style={{
          padding: "0 10px",
          color: isNull(themeList.header_color)
            ? "#797979"
            : themeList.header_color,
        }}>
        {capitalizeFirst(getUserName())}
      </div>

      <div
        className='top-nav-bars'
        style={{
          color: isNull(themeList.header_color)
            ? "#797979"
            : themeList.header_color,
        }}>
        |
      </div>

      <button
        type='button'
        className='logout'
        onClick={handleClickLogout}
        style={{ padding: "0 0 0 10px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-6 w-6 top-nav-bars'
            width='20px'
            style={{
              color: isNull(themeList.header_color)
                ? "#797979"
                : themeList.header_color,
              marginRight: "0.5rem",
            }}
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'
            />
          </svg>
          <div
            className='top-nav-bars'
            style={{
              fontSize: "15px",
              color: isNull(themeList.header_color)
                ? "#797979"
                : themeList.header_color,
            }}>
            Keluar
          </div>
        </div>
      </button>
    </>
  );
}

export default UserInformationWihoutSso;
